import { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import { faqSchema } from "../../../Validation/Validation";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";
import CodeEditor from "../../../Components/CodeEditor";

const AddFAQ = () => {
  const { typeId } = useParams();
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;

  const initalvalues = {
    question: editData?.question || "",
    answer: editData?.answer || "",
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? true,
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: faqSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(`/faq/updateFAQ/${editingId}`, values)
          : await axiosInstance.post("/faq/createFAQ", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator(`/faqs`);
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "FAQ's", path: `/faqs` },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} FAQ
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label
                        htmlFor="client-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control  `}
                        id="client-sortOrder"
                        name="sortOrder"
                        placeholder="Enter client Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="faq-question" className="col-form-label">
                        Question
                      </label>

                      <textarea
                        className="form-control border border-dark"
                        id="faq-question"
                        name="question"
                        placeholder="Enter your question"
                        rows={10}
                        value={values.question || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />

                      {touched.question && errors.question && (
                        <small className="text-danger">{errors.question}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="faq-answer" className="col-form-label ">
                        Answer
                      </label>

                      <CodeEditor
                        value={values.answer}
                        onChange={(val) => setFieldValue("answer", val)}
                      />

                      {touched.answer && errors.answer && (
                        <small className="text-danger">{errors.answer}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to={`/faqs`}>
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddFAQ;
